
export const floridaoranges_Serbian= 
    {
      "id": 0,
      "name": "Proizvodnja jabuka",
      "prompts": [
        {
          "id": 1,
          "who": "Polugodisnjni izvestaj: Proizvodnja jabuka",
          "what": "Polugodiste: January - Jun"
        },
        {
          "id": 2,
          "who": "1. Pregled: ",
          "what": "ukupna proizvodnja, vremenski uslovi, izazovi koje smo imali,projekcija za naredni period proizvodnje jabuka u zemlji"
        },
        {
          "id": 3,
          "who": "2. Ukupna proizvodnja jabuka",
          "what": "Ukupno 2.5 miliona kutija. 10% povecana proizvodnja u poredjenju sa istim periodom prosle godine."
        },
        {
          "id": 4,
          "who": "3. Vremenski uslovi: ",
          "what": "Umerene temperature sa odgovarajucom kisom. Povremeni hladni talasi i mraz primeceni."
        },
        {
          "id": 5,
          "who": "4. Izazovi koje smo imali: ",
          "what": "Tekuci problem sa jabucnom bolescu. Nedostatak radne snage.Porast troskova proizvodnje."
        },
        {
          "id": 6,
          "who": "5. Potraznja trzista i izvoz: ",
          "what": "Stabilan interest i domaci i strani. Povecana prodaja: Europe, Afrika."
        },
        {
          "id": 7,
          "who": "6. Projekcija za buducnost:",
          "what": "Ocekuje se da proizvodnja ostane stabilna. Primena zastitnih mera protiv bolesti. Pazljivo pracenje vremena.."
        },
        {
          "id": 8,
          "who": "7. Zakljucak:",
          "what": "Napisi izvestaj na osnovu gornji podataka. Koristi iste naslove."
        }
  
      ]
    }
    
    export const performancereview_Serbian= 
    {
      "id": 0,
      "name": "Performance Review",
      "prompts": [
        {
          "id": 1,
          "who": "Zadatak:",
          "what": "Napisi izveštaj o radu zaposlenog."
        },
        {
          "id": 2,
          "who": "Ime:",
          "what": "Petar Petrovic"
        },
        {
          "id": 3,
          "who": "Pozicija:",
          "what": "Mladji programer"
        },
        {
          "id": 4,
          "who": "Ispunjava ciljeve:",
          "what": "Ispunjava ciljeve veoma cesto. Njegov kod je veoma cist i bez gresaka."
        },
        {
          "id": 5,
          "who": "Clan tima:",
          "what": "Odlicno se uklopio. Cenjen je."
        },
  
      ]
    }

    export const inventory = 
    {
      "id": 0,
      "name": "Calculation",
      "prompts": [
        {
          "id": 1,
          "who": "Required quantity:",
          "what": `coffee bags: 100\ntea begs: 30\neggs: 3 dozen\nmilk: 5 gallons`
        },
        {
          "id": 2,
          "who": "Used quantity:",
          "what": `coffee bags: 20\nmilk: 2 gallons\neggs: 1 dozen\ntea: 2 begs`
        },
        {
          "id": 3,
          "who": "Task:",
          "what": `What needs to be ordered to resupply all items?\nPresent data in a CSV format and a tabular form.`
        },
      ]
    }




export const emails = 
    {
        "id": 0,
        "name": "Email",
        "prompts": [
          {
            "id": 1,
            "who": "Task",
            "what": "Write an email about this property."
          },
          {
            "id": 2,
            "who": "Property",
            "what": "Two story house"
          },
          {
            "id": 3,
            "who": "Bedrooms",
            "what": "4"
          },
          {
            "id": 4,
            "who": "Bathrooms",
            "what": "3.5"
          },
          {
            "id": 5,
            "who": "Condition",
            "what": "recent update"
          },
          {
            "id": 6,
            "who": "City",
            "what": "Evanston"
          },
          {
            "id": 7,
            "who": "Schools",
            "what": "Top ranked elementary and second grade schools"
          },
          {
            "id": 8,
            "who": "Restaurants",
            "what": "Many upscale dinning options"
          },
          {
            "id": 9,
            "who": "To:",
            "what": "John"
          },
          {
            "id": 10,
            "who": "From:",
            "what": "Marry"
          }

        ]
    }


export const extraction=
    {
        "id":0,
        "name": "Group products",
        "prompts":[
            {
                "id":1,
                "who":"Products:",
                "what":"Oranges grow in California and Florida. Main tomato producers are in Florida, Apples are important product for state of Michigan. Texas is the main producer of beef, and Wisconsin of chees."
            },
            {
                "id":2,
                "who":"Task:",
                "what":"Group the following products by the region."
            },
            {
                "id":3,
                "who":"Task:",
                "what":"Group the regions by the products."
            },

        ]
    }

    export const productdescription =
    {
        "id":0,
        "name": "Brown bag",
        "prompts":[
            {
                "id":1,
                "who":"Task:",
                "what":"Describe the following product:"
            },
            {
                "id":2,
                "who":"What:",
                "what":"Leather bag"
            },
            {
                "id":3,
                "who":"Color:",
                "what":"brown"
            },
            {
                "id":4,
                "who":"Style:",
                "what":"business style"
            },
            {
                "id":5,
                "who":"Price:",
                "what":"$79"
            },

        ]
    }

    export const problemsolving=
    {
        "id":0,
        "name": "Tom and Peter",
        "prompts":[
            {
                "id":1,
                "who":"Who",
                "what":"Tom and Peter"
            },
            {
                "id":2,
                "who":"Location",
                "what":"Tom is in town A, Peter is in town B."
            },
            {
                "id":3,
                "who":"Distance",
                "what":"Distance between town A and town B is 15 miles."
            },
            {
                "id":4,
                "who":"Walking speed",
                "what":`Tom walks 2 mi/h
                \nPeter walks 3mi/h`
            },
            {
                "id":5,
                "who":"Task",
                "what":"If Tom and Peter start walking toward each other at the same time how long is it going to take before they meet?"
            },

        ]
    }

    export const email_Serbian = 
    {
      "id": 0,
      "name": "E-posta",
      "prompts": [
        {
          id: 1,
          who: "Kome:",
          what: "Petar Lazic",
        },
        {
          "id": 2,
          "who": "Tema: Konferencija o solarnim panelima",
          "what": "Planiranje puta za Beograd na \"Godisnju konferenciju o solarnim panelima\"."
        },
        {
          "id": 3,
          "who": "Datum:",
          "what": "Sept 25-29"
        },
        {
          "id": 4,
          "who": "Pozdrav:",
          "what": "Zoran Jokic"
        },
        {
          "id": 5,
          "who": "Zadatak:",
          "what": "Napisi text e-poste."
        },
        
      ]
    }

    export const travelexpense_Serbian= 
    {
      "id": 0,
      "name": "Troskovi puta",
      "prompts": [
        {
          id: 1,
          who: 'Naslov:',
          what: 'Pokazi ovo kao naslov: Put u Madrid'
        },
        {
          id: 2,
          who: 'Prevoz:',
          what: 'Avionska karta: 56.000 dinara.\nTaxi prevoz: 15.600 dinara'
        },
        {
          id: 3,
          who: 'Hotelski smestaj:',
          what: 'Hotel - 2 noci: 35.000 dinara'
        },
        {
          id: 4,
          who: 'Hrana:',
          what: 'Dorucak: 5.600\nRucak: 7.800\nVecera: 12.000\nDodaci: 1.300'
        },
        {
          id: 5,
          who: 'Zadatak:',
          what: 'Navedi sve troskove u odvojenim linijama.\nNa kraju prikazi ukupan trosak.'
        }
        
      ]
    }

    
    